<template lang="html">
  <div id="app">
    <div class="mt-16 text-center flex justify-center w-full">
      <form class="needs-validation w-full xs:w-3/4 sm:w-5/6 md:w-2/3 lg:w-1/2" novalidate action="/users/login" method="post">
        <input type="hidden" id="authenticity_token" value="" name="authenticity_token">
        <!-- <div>
          <label class="block text-sm text-white">Email</label>
          <input class='fs-input' placeholder="Email" v-model="user.login" required name="user[login]" />
          <div class="invalid-feedback">Must supply your email address</div>
        </div> -->

        <div class="relative mt-3">
          <div class="flex absolute inset-y-0 left-0 items-center pl-3 mb-2">
            <svg aria-hidden="true" class="w-6 h-6 text-rspurple" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z"/></svg>
          </div>
          <input class='fs-input pl-10' placeholder="Email" v-model="user.login" required name="user[login]" />
          <div class="invalid-feedback">Please enter your email address</div>
        </div>

        <div class="relative mt-3">
          <div class="flex absolute inset-y-0 left-0 items-center pl-3 mb-3">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-lock-fill w-6 h-6 text-rspurple" viewBox="0 0 16 16">
              <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zM5 8h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z"/>
            </svg>
          </div>
          <input class='fs-input pl-10' placeholder="Password" type="password" v-model="user.password" required name="user[password]" />
          <div class="invalid-feedback">Please type your password</div>
        </div>

       <!--  <div>
          <label class="block text-sm text-white">Password</label>
          <input class='fs-input' placeholder="Password" type="password" v-model="user.password" required name="user[password]" />
          <div class="invalid-feedback">Please type your password</div>
        </div> -->

        <div class="mt-16">
          <input type="submit" name="commit" value="Login" class="rs-purple-btn mt-2 w-48 h-12">
        </div>
      </form>
    </div>
    <div class="text-xs text-center grid mt-8">
      <a href="/users/password/new" class="fs-link underline mb-2">Forgot your password?</a>
<!--       <a href="/users/confirmation/new" class="fs-link underline">Didn't receive confirmation instructions?</a>
 -->    </div>
  </div>

</template>

<script>

  export default {
    components: {
    },
    props: {
      stadium_code: String,
      stadiumInfo: Object,
    },
    data() {
      return {
        user: {},
      }
    },
    validations: {
    },
    created(){
    },
    mounted() {
      this.$parent.show_top_section = true;
      document.getElementById("authenticity_token").value = document.getElementsByName('csrf-token')[0].getAttribute('content');
      var forms = document.getElementsByClassName('needs-validation');
      var validation = Array.prototype.filter.call(forms, function(form) {
        form.addEventListener('submit', function(event) {
          if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
          }
          form.classList.add('was-validated');
        }, false);
      });
    },
    methods: {
    }
  };
</script>

<style scoped>
.fs-peach-btn {
  @apply bg-peach text-center py-2 px-6 rounded-full cursor-pointer outline-none font-semibold text-xs w-full;
  min-width:auto;
}

.fs-darkgrey-btn {
  @apply bg-darkgrey text-center py-2 px-6 rounded-full cursor-pointer outline-none font-semibold text-xs w-full;
  min-width:auto;
}
</style>
